const sanitizeRegex = /[\\/:*?"<>|]/g;

export const buildPdfFilename = (filenameRaw?: string) => {
  const base = (filenameRaw || 'document').replace(sanitizeRegex, '').trim();
  const withExt = base.toLowerCase().endsWith('.pdf') ? base : `${base}.pdf`;

  return withExt;
};
